module.exports = __webpack_public_path__ + "media/images/menu-white-arrow-b2dfc566.png";